// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ban-icon{font-size:10em;color:#79757a;z-index:1}.mobile-icon{position:absolute;font-size:6em;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);color:#928f93}", ""]);
// Exports
module.exports = exports;
